import { EvtHeader } from "components/header";
import React from "react";
import { useParams } from "react-router-dom";
import FunctionForm from "../form";

const UpdateFunction = () => {
  const { functionId } = useParams();

  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Update Function" />
      <div className="p-6 max-w-2xl">
        <FunctionForm functionId={functionId} />
      </div>
    </div>
  );
};

export default UpdateFunction;
